export const OPERATIONS = [
  { value: "=", label: "=", isMultiSelect: false },
  { value: ">", label: ">", isMultiSelect: false },
  { value: "<", label: "<", isMultiSelect: false },
  { value: "in", label: "IN", isMultiSelect: true },
];
